module.exports = __webpack_public_path__ + "media/images/athletes/2366-947304e54cf1f72443dae96659512d44.png";